"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stencilToContentTypeMapping = exports.supportedStencilContentTypes = void 0;
exports.supportedStencilContentTypes = [
    'apple-immersive-videos',
    'audio-clips',
    'audio-episodes',
    'audio-series',
    'audio-seasons',
    'author-profiles',
    'collections',
    'energy-drinks',
    'episode-videos',
    'event-details',
    'event-profiles',
    'event-seasons',
    'event-series',
    'externals',
    'external-persons',
    'external-teams',
    'films',
    'images',
    'image-galleries',
    'immersive-3d-models',
    'judges',
    'live-videos',
    'locations',
    'misc',
    'occasions',
    'occasion-campaigns',
    'onsite-promotions',
    'partner-profiles',
    'photographers',
    'person-profiles',
    'preview-clips',
    'project-profiles',
    'rally-drivers',
    'rally-teams',
    'recap-videos',
    'results-standings',
    'seasons',
    'shows',
    'stories',
    'tags',
    'team-profiles',
    'trailer-videos',
    'tv-commercials',
    'tv-partner-channels',
    'video-3d',
    'videos',
    'video-channels',
    'videos-360',
];
exports.stencilToContentTypeMapping = {
    'apple-immersive-video': 'apple-immersive-videos',
    artist: 'person-profiles',
    athlete: 'person-profiles',
    'audio-clip': 'audio-clips',
    author: 'author-profiles',
    collection: 'tags',
    'content-category': 'tags',
    'content-collection': 'collections',
    'content-hub': 'collections',
    country: 'locations',
    discipline: 'tags',
    'editorial-list': 'collections',
    'energy-drink': 'energy-drinks',
    'episode-video': 'episode-videos',
    'event-details': 'event-details',
    'event-profile': 'event-profiles',
    'event-season': 'event-seasons',
    'event-series': 'event-series',
    'external-content-resource': 'externals',
    'external-person': 'external-persons',
    'external-team': 'external-teams',
    film: 'films',
    geolocation: 'locations',
    image: 'images',
    'image-gallery': 'image-galleries',
    'immersive-3d-model': 'immersive-3d-models',
    judge: 'judges',
    'live-video': 'live-videos',
    misc: 'misc',
    'partner-profile': 'partner-profiles',
    lsc: 'tags',
    'occasion-campaign': 'occasion-campaigns',
    occasion: 'occasions',
    'onsite-promotion': 'onsite-promotions',
    photographer: 'photographers',
    playground: 'tags',
    'podcast-episode': 'audio-episodes',
    'podcast-show': 'audio-series',
    'podcast-season': 'audio-seasons',
    'preview-clip': 'preview-clips',
    'project-profile': 'project-profiles',
    'rally-driver': 'rally-drivers',
    'rally-team': 'rally-teams',
    'recap-video': 'recap-videos',
    'results-and-standings': 'results-standings',
    season: 'seasons',
    show: 'shows',
    story: 'stories',
    team: 'team-profiles',
    'trailer-video': 'trailer-videos',
    'tv-commercial': 'tv-commercials',
    'tv-partner-channel': 'tv-partner-channels',
    'video-3d': 'video-3d',
    video: 'videos',
    'video-channel': 'video-channels',
    'video-vr-360': 'videos-360',
    'virtual-geolocation': 'locations',
    'worldwide-geolocation': 'locations',
};
//# sourceMappingURL=data:application/json;base64,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